import { ArrowRight, ArrowUpRight } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { Reveal } from "./Reveal";

export const FinalCTA = () => {
    const { t } = useLanguage();
    return (
        <section data-testid="final-cta-section" className="relative overflow-hidden border-t border-white/5 bg-nx-alt py-24 sm:py-28 lg:py-36">
            <div className="pointer-events-none absolute inset-0 flex items-center justify-center" aria-hidden="true">
                <img src="/assets/nexora-eagle.png" alt="" className="w-[520px] max-w-[80vw] opacity-[0.05] blur-[1px]" />
            </div>
            <div className="pointer-events-none absolute left-1/2 top-1/2 h-72 w-[40rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-nx-lime/[0.05] blur-[110px]" aria-hidden="true" />

            <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-6">
                <Reveal>
                    <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.06] text-nx-text text-balance">
                        {t("Build the Future of")} <span className="text-nx-lime">{t("Decentralized")}</span> {t("Finance.")}
                    </h2>
                </Reveal>
                <Reveal delay={0.12}>
                    <p className="mx-auto mt-6 max-w-xl text-base lg:text-lg leading-relaxed text-nx-sub">
                        {t("Explore Nexora Global and discover its smart-contract, matrix, token and Web3 ecosystem.")}
                    </p>
                </Reveal>
                <Reveal delay={0.22} className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
                    <a
                        href="#join"
                        data-testid="final-join-button"
                        className="btn-sweep group inline-flex items-center justify-center gap-2 rounded-full bg-nx-lime px-8 py-4 text-sm font-extrabold tracking-wide text-nx-base shadow-[0_6px_32px_rgba(184,255,24,0.25)] transition-all duration-300 hover:brightness-110 hover:-translate-y-px"
                    >
                        {t("Join Nexora")}
                        <ArrowRight size={16} strokeWidth={2} className="transition-transform duration-300 group-hover:translate-x-0.5 rtl:rotate-180" aria-hidden="true" />
                    </a>
                    <a
                        href="#ecosystem"
                        data-testid="final-ecosystem-button"
                        className="group inline-flex items-center justify-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-8 py-4 text-sm font-bold tracking-wide text-nx-text backdrop-blur-sm transition-all duration-300 hover:bg-white/[0.08] hover:-translate-y-px"
                    >
                        {t("View Ecosystem")}
                        <ArrowUpRight size={16} strokeWidth={2} className="text-nx-sub transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" />
                    </a>
                </Reveal>
            </div>
        </section>
    );
};
